import React, { useState } from 'react';

import {
  Form,
  FormItem,
  SubmitButton,
  Button,
  Input,
} from '../../../../../components';
import { validateName } from '../../utils/validator';
import type { ActionType } from '../knowledge-base-list';

export type FormProps = {
  name: string;
};
type TaskFormProps = {
  saving: boolean;
  actionType: ActionType;
  onCancel: () => void;
  onSave: (data: FormProps) => void;
  isSource?: boolean;
  values?: FormProps;
};

const KnowledgeBaseForm: React.FC<TaskFormProps> = ({
  saving,
  onSave,
  onCancel,
  actionType,
  isSource = false,
  values,
}) => {
  const [formValues, setFormValues] = useState<FormProps>({
    name: values?.name || '',
  });
  const label = isSource ? 'Source' : 'Knowledge Base';

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <Form onChange={setFormValues} initialValue={formValues}>
        <FormItem<FormProps>
          required
          name="name"
          label={`${label} Name`}
          inline={false}
          validate={validateName}
        >
          <Input placeholder={`${label} Name`} />
        </FormItem>

        <div className="flex flex-col gap-y-md justify-center items-center">
          <SubmitButton
            size="medium"
            disabled={saving}
            className="w-full"
            label={actionType === 'create' ? 'Create' : 'Update'}
            onClick={() => onSave({ name: formValues.name })}
          />
          <Button
            size="medium"
            type="contrast"
            label="Cancel"
            className="w-full text-main"
            onClick={onCancel}
          />
        </div>
      </Form>
    </div>
  );
};

export default KnowledgeBaseForm;
